/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Who_WordInputs */

const en_wc_vs_who_word = /** @type {(inputs: Wc_Vs_Who_WordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stay with Word if you`)
};

/**
* | output |
* | --- |
* | "Stay with Word if you" |
*
* @param {Wc_Vs_Who_WordInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_who_word = /** @type {((inputs?: Wc_Vs_Who_WordInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Who_WordInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_who_word(inputs)
});
export { wc_vs_who_word as "wc.vs.who_word" }